import { Injectable, signal, computed, OnDestroy } from '@angular/core';

export type DeviceType = 'desktop' | 'mobile';

const MOBILE_BREAKPOINT = 1024;

@Injectable({ providedIn: 'root' })
export class DeviceService implements OnDestroy {

  private readonly _windowWidth = signal<number>(
    typeof window !== 'undefined' ? window.innerWidth : 1280
  );

  /** Signal public — 'desktop' | 'mobile' */
  readonly device = computed<DeviceType>(() =>
    this._windowWidth() < MOBILE_BREAKPOINT ? 'mobile' : 'desktop'
  );

  readonly isMobile  = computed(() => this.device() === 'mobile');
  readonly isDesktop = computed(() => this.device() === 'desktop');

  private _resizeObserver?: ResizeObserver;

  constructor() {
    if (typeof window === 'undefined') return; // SSR guard
    this._resizeObserver = new ResizeObserver(() => {
      this._windowWidth.set(window.innerWidth);
    });
    this._resizeObserver.observe(document.body);
  }

  ngOnDestroy(): void {
    this._resizeObserver?.disconnect();
  }
}
